import { Component, OnInit, signal, inject, ChangeDetectionStrategy } from '@angular/core';
import { first } from 'rxjs/operators';
import { StateService } from '@uirouter/angular';

import { BackgroundBrandedService } from '@app/shared/modules/background-branded/services/background-branded.service';
import { CompanyService } from '@app/shared/services/company.service';

import { IFBCompany } from '@interfaces';

@Component({
  selector: 'app-register-blocked',
  templateUrl: './register-blocked.component.html',
  styleUrl: '../register.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterBlockedComponent implements OnInit {
  private backgroundBrandedService = inject(BackgroundBrandedService);
  private companyService = inject(CompanyService);
  private stateService = inject(StateService);

  isLoaded = signal(false);
  company = signal<IFBCompany>(this.companyService.data);
  logInUrl = signal<string>(null);

  ngOnInit() {
    this.logInUrl.set(this.stateService.href('login'));
    this.backgroundBrandedService
      .fetchBranding()
      .pipe(first())
      .subscribe(() => {
        this.isLoaded.set(true);
      });
  }
}
